<template>
	<div class="container">
		<!-- 新闻列表 -->
		<div class="list" v-for="(val,key) in news" :key='key'  >
			<el-image :src="val.image" class="news" fit="cover"></el-image>
			<div class="info">
				<div class="title" v-if="$i18n.locale == 'zh'">
					{{val.title}}
				</div>
				<div class="title" v-else-if="$i18n.locale == 'en'">
					{{val.y_title}}
				</div>
				<div class="title" v-else>
					{{val.e_title}}
				</div>

				<div class="text" v-html="val.content" v-if="$i18n.locale == 'zh'">
				</div>
				<div class="text" v-html="val.y_content" v-else-if="$i18n.locale == 'en'">
				</div>
				<div class="text" v-html="val.e_content" v-else>
				</div>
				<div>
					<!-- <div class="link" @click="$router.push({ path:'/NewsCenter/detail' + val.id });$router.go(0)"> -->
					<div class="link" @click="$router.push({ path:'/NewsCenter/detail' + val.id });">
						{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
					</div>
					<div class="time">
						{{val.create_time}}
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="list">
			<el-image src="./static/image/head1.png" class="news" fit="cover"></el-image>
			<div class="info">
				<div class="title">
					新征程！天宏达安今日在香港联交所挂牌上市
				</div>
				<div class="text">
					2021年12月10日，天宏达安医药集团公开发行H股在香港联交所主板挂牌上市。本次全球发售。随着H股的成功发行，正值A股上市五周年，实现“A+H”两地上市，再创前行之路的又一里程碑。过去二十余年，逐渐脱颖而出，成为全球领先的CDMO技术平台，解决小分子药物开发及...
				</div>
				<div class="link">
					查看更多<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
				</div>
				<div class="time">
					2021年12月30日
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				news:[],
				page:1,
				limit:10,
				type:'',
			}
		},
		mounted() {
			console.log('dddd');
			this.type = this.$route.params.type;
            this.getNews()
		},
		methods: {
            getNews() {
				var that = this;
				this.$axios
					.post("/api/index/news", {
						type:this.type,
						page:this.page,
						limit:this.limit,
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.news = ret.data.data.news
							console.log(ret.data.data.news)
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.list {
			width: 900px;
			border-bottom: 1px solid #D8D8D8;
			padding-bottom: 20px;
			margin-bottom: 20px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.news {
				width: 280px;
				height: 210px;
			}

			.info {
				width: 600px;
				// height: 210px;
				display: flex;
				// justify-content: space-between;
				flex-direction: column;

				.title {
					font-size: 20px;
					color: #333;
					font-weight: bold;

					overflow: hidden;
					 display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
				.link {
					font-size: 16px;
					color: #004098;
					display: flex;
					align-items: center;
					cursor: pointer;
					margin-top: 20px;
					.el-image {
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}
				
				.text {
					margin-top: 10px;
					font-size: 14px;
					color: #666;
					overflow: hidden;
					// max-height: 80px;
					 display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
				}

				.time {
					font-size: 12px;
					color: #999;
					margin-top: 10px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/NewsCenter/news.vue